import React from 'react';
import { StarIcon } from '@heroicons/react/24/solid';
import { StarIcon as StarOutline } from '@heroicons/react/24/outline';

// Order rating yıldız gösterimi: N dolu + (max-N) boş + sayısal değer.
const StarRating = ({ value = 0, max = 5 }) => (
  <span
    className="inline-flex items-center gap-0.5"
    aria-label={`${value} out of ${max} stars`}
  >
    {Array.from({ length: max }).map((_, i) =>
      i < value ? (
        <StarIcon key={i} className="h-4 w-4 text-amber-400" />
      ) : (
        <StarOutline
          key={i}
          className="h-4 w-4 text-slate-300 dark:text-slate-600"
          strokeWidth={1.5}
        />
      ),
    )}
    <span className="ml-1.5 text-xs font-semibold tabular-nums text-slate-500 dark:text-slate-400">
      {value}
    </span>
  </span>
);

export default StarRating;
